/**
 * Shared tuning for the global command-palette search (IMM-448).
 *
 * These live in the contract package rather than in the web app because both
 * ends read them: the palette decides when to start searching, and the search
 * endpoint validates the same floor. Two copies would drift into a UI that
 * queries below the minimum the API accepts.
 */

/** Shortest query that runs a search. Below it the palette shows quick-nav. */
export const MIN_SEARCH_QUERY_LENGTH = 2;

/**
 * Longest query the endpoint accepts. `unaccent()` is not index-usable, so an
 * unbounded pattern is an unbounded sequential scan — across every registered
 * source at once.
 */
export const MAX_SEARCH_QUERY_LENGTH = 200;

/** How long the palette waits after the last keystroke before it asks. */
export const SEARCH_DEBOUNCE_MS = 150;

/** Rows a single entity group ever returns. The true count rides alongside. */
export const SEARCH_GROUP_LIMIT = 5;

/**
 * The entity types the palette searches, in the fixed order their groups
 * render. The order is a property of the contract, never of the order sources
 * happen to be registered in — the palette's structure must be predictable
 * regardless of what matched.
 */
export const SEARCH_ENTITY_ORDER = ['kontakt', 'objekt', 'deal', 'lead', 'dokument'] as const;

export type SearchEntityType = (typeof SEARCH_ENTITY_ORDER)[number];
